module.exports = __webpack_public_path__ + "img/仿真恐龙公仔.df77e18a.jpg";